import { render, staticRenderFns } from "./HomeFormerProducts.vue?vue&type=template&id=3979995b&scoped=true"
import script from "./HomeFormerProducts.vue?vue&type=script&lang=js"
export * from "./HomeFormerProducts.vue?vue&type=script&lang=js"
import style0 from "./HomeFormerProducts.vue?vue&type=style&index=0&id=3979995b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3979995b",
  null
  
)

export default component.exports